import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=4bb68a4d&scoped=true"
var script = {}
import style0 from "./SubNav.vue?vue&type=style&index=0&id=4bb68a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb68a4d",
  null
  
)

export default component.exports